import { ReactNode, useState, useEffect } from "react";
import { motion } from "framer-motion";
import Sidebar from "../elements/Sidebar";
import { Menu } from "lucide-react";
import Logo from "../assets/images/dealer-logo-dark.png";
import LogoDark from "../assets/images/dealer-logo.png";
import withLoader from "../redux/Hoc/withLoader";

type LayoutProps = {
  children: ReactNode;
};

function Layout({ children }: LayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  useEffect(() => {
    // On mobile, start with sidebar closed
    const checkScreenSize = () => {
      if (window.innerWidth < 768) {
        setSidebarOpen(false);
      } else {
        setSidebarOpen(true);
      }
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="flex h-screen bg-gray-50 dark:bg-primary">
      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} onToggle={toggleSidebar} />

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Mobile Header */}
        <div className="md:hidden flex items-center justify-between p-4 bg-white dark:bg-primary border-b border-gray-200 dark:border-secondary shadow-sm">
          <button
            onClick={toggleSidebar}
            className="text-gray-600 dark:text-gray-400 p-2 hover:bg-gray-100 dark:hover:bg-secondary rounded-lg transition-colors"
          >
            <Menu size={24} />
          </button>
          <div className="flex-1 flex items-center justify-center relative">
            <motion.img
              className="h-8 hidden dark:block"
              src={Logo}
              alt="ivin logo"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
            />
            <motion.img
              className="h-8 dark:hidden"
              src={LogoDark}
              alt="ivin logo"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
            />
          </div>
          <button className="pointer-events-none opacity-0 text-gray-600 dark:text-gray-400 p-2 hover:bg-gray-100 dark:hover:bg-secondary rounded-lg transition-colors">
            <Menu size={24} />
          </button>
        </div>

        {/* Content Area */}
        <div className="flex-1 overflow-hidden bg-gray-50 dark:bg-primary">
          {children}
        </div>
      </div>
    </div>
  );
}

export default withLoader(Layout);
